"use client";
import { useRef } from "react";
const UNINITIALIZED = {};
function useRefWithInit(init, initArg) {
    const ref = useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) {
        ref.current = init(initArg);
    }
    return ref;
}
export { useRefWithInit };
//# sourceMappingURL=useRefWithInit.js.map